/**
 * Clear large cookies that can cause 431 errors
 * This should be called once on app initialization to migrate from cookies to localStorage
 */
export const clearLargeCookies = () => {
  try {
    const cookies = document.cookie.split(';')
    const cookiesToClear = []

    cookies.forEach(cookie => {
      const [name] = cookie.split('=')
      const trimmedName = name.trim()

      // Clear expandedFolders cookies (moved to localStorage)
      if (
        trimmedName.includes('expandedFolders') ||
        trimmedName.includes('customExpandedFolders')
      ) {
        cookiesToClear.push(trimmedName)
      }
    })

    // Clear the identified cookies
    cookiesToClear.forEach(cookieName => {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      console.log(`Cleared large cookie: ${cookieName}`)
    })

    if (cookiesToClear.length > 0) {
      console.log(`✅ Cleared ${cookiesToClear.length} large cookies to prevent 431 errors`)
    }
  } catch (error) {
    console.warn('Failed to clear large cookies:', error)
  }
}
